import loginState from "state/singletons/loginState";

const ENVIRONMENTS = ["local", "staging", "production"] as const;
const CITIES = ["wuppertal", "saarlouis"] as const;

type City = typeof CITIES[number];
type Environment = typeof ENVIRONMENTS[number];

const CONFIG = {
  wuppertal: {
    local: {
      IMAGESTORAGE_URL: "https://wsaistagingimage0.blob.core.windows.net/",
      PAYONE_INTEGRATION_ENABLED: true,
    },
    staging: {
      IMAGESTORAGE_URL: "https://wsaistagingimage0.blob.core.windows.net/",
      PAYONE_INTEGRATION_ENABLED: true,
    },
    production: {
      IMAGESTORAGE_URL: "https://wsaiprodimagestore.blob.core.windows.net/",
      PAYONE_INTEGRATION_ENABLED: true,
    },
  },
  saarlouis: {
    local: {
      IMAGESTORAGE_URL:
        "https://bliggitslsstagingimages.blob.core.windows.net/",
      PAYONE_INTEGRATION_ENABLED: true,
    },
    staging: {
      IMAGESTORAGE_URL:
        "https://bliggitslsstagingimages.blob.core.windows.net/",
      PAYONE_INTEGRATION_ENABLED: true,
    },
    production: {
      IMAGESTORAGE_URL: "https://bliggitslsprodimages.blob.core.windows.net/",
      PAYONE_INTEGRATION_ENABLED: true,
    },
  },
};

export function getConfig(city: City, environment: Environment) {
  const cityConfig = CONFIG[city]?.[environment];
  if (!cityConfig) {
    throw new Error(
      `Configuration not found for city: ${city}, environment: ${environment}`,
    );
  }
  return cityConfig;
}

export function useCityConfig() {
  const { state } = loginState;
  const activeCity =
    (state.activeCityScope?.city.toLocaleLowerCase() as City) || "wuppertal";
  const environment = process.env.REACT_APP_ENV as Environment;

  if (!activeCity || !CITIES.includes(activeCity)) {
    throw new Error(`Invalid or missing city: ${activeCity}`);
  }
  if (!environment || !ENVIRONMENTS.includes(environment)) {
    throw new Error(`Invalid or missing environment: ${environment}`);
  }

  return getConfig(activeCity, environment);
}
